import { render, staticRenderFns } from "./ClickList.vue?vue&type=template&id=270323ba&lang=pug&"
import script from "./ClickList.vue?vue&type=script&lang=js&"
export * from "./ClickList.vue?vue&type=script&lang=js&"
import style0 from "./ClickList.vue?vue&type=style&index=0&id=270323ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports